import $ from "jquery";
import axios from "axios";

export const commentsHandlers = () => {
    $(document).on('click', '.notification-item', function () {
        if ($(this).attr('href').indexOf(document.location.pathname)) {
            window.location.reload();
            window.scroll(0, $('.comment-replies').offset().top - window.screen.height / 3);
        }
    });

    $(document).on('click', '.plate__comments', function () {
        goToMaterialComments($(this).parents('.plate__part').find('.plate__title > a').attr('href'));
    });

    $(document).on('click', '.mega-block-plate__comments', function () {
        goToMaterialComments($(this).parents('.mega-block-cell').find('.mega-block-plate__title > a').attr('href'));
    });
};

const goToMaterialComments = (url) => {
    window.location.href = url + '#comments';
};
